import { getValue } from './dom-utils.js';

export const fetchData = (dataUrlSelector, action, ...params) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const url = getValue(dataUrlSelector);
        
        const queryParams = params.map((param, index) => 
            `param${index+1}=${encodeURIComponent(param || '')}`).join('&');
            
        xhr.open("GET", `${url}?op=${action}&${queryParams}`, false);
        
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    resolve(JSON.parse(xhr.response));
                } catch (e) {
                    resolve(xhr.response);
                }
            } else {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            }
        };
        
        xhr.onerror = function() {
            reject({
                status: xhr.status,
                statusText: xhr.statusText
            });
        };
        
        xhr.send();
    });
};